import Integrations from './Integrations'
import withState from './withState'

export default withState(Integrations)
